var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240.89 36.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#009fe3;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-light") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,18.41c0,.25,0,.49,0,.73l.07,0c4.17-1,7.89.1,10.88.95,2.78.79,4.54,1.24,5.67.44,2-1.39,3.24-6.84,3.79-16.19A29.6,29.6,0,0,0,20.4.11a18.81,18.81,0,0,0-2-.11A18.41,18.41,0,0,0,0,18.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.45,1a34.44,34.44,0,0,1,0,3.52C23.77,15.92,22.18,21.49,19,23.77c-2.74,1.95-6,1-9.08.15C7.08,23.12,4.17,22.29,1,23l-.39.1A18.4,18.4,0,1,0,24.45,1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.88,4.21a.88.88,0,0,1,.82-1H73.79a.9.9,0,0,1,1,1V9.46a1,1,0,0,1-1,1H61V20.73h9.42a.85.85,0,0,1,.95.92v5a1,1,0,0,1-.9,1H61v5.84c0,.61-.32.9-1,.9h-6.4a.81.81,0,0,1-.76-.88Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.17,4.16a.87.87,0,0,1,.93-.92h6.17a1,1,0,0,1,1,.92V33.5c0,.6-.34.92-1,.92H80.1a.83.83,0,0,1-.93-.92Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.44,23.56l-12.73-10V33.5c0,.6-.35.92-1,.92H95.51a.83.83,0,0,1-.92-.9V4.16a.87.87,0,0,1,.92-.92h6.24a4.22,4.22,0,0,1,1.78.65l11.91,9.51V4.16a.87.87,0,0,1,.92-.92h6.17a1.06,1.06,0,0,1,1,.92V33.5c0,.6-.35.92-1,.92h-6.17a.82.82,0,0,1-.92-.92Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.91,4.16a.91.91,0,0,1,1-.92h22.61a1,1,0,0,1,1,.92V9.39a1,1,0,0,1-1,1.07h-7.24v23a1,1,0,0,1-1,1h-6.17a1,1,0,0,1-1-1v-23H128.9a1,1,0,0,1-1-1.07Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.62,4.21a.88.88,0,0,1,.92-1h20.85a.92.92,0,0,1,1,1V9.46a1,1,0,0,1-1,1h-13.6v6.89h10.49c.53,0,.93.23.93.82V22.7a.86.86,0,0,1-.9.84H164.77V27.2h14.11a.83.83,0,0,1,.94,1v5.29a1,1,0,0,1-1,1H157.54a.82.82,0,0,1-.92-.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.51,6.85l-3.54,5c-.32.44-.65.63-1.14.23a7.73,7.73,0,0,0-4.89-1.61c-4.6,0-7.89,3.71-7.89,8.31s3.29,8.27,7.89,8.27a8.16,8.16,0,0,0,4.93-1.64.73.73,0,0,1,1.14.19l3.59,5.17c.33.48.06,1-.46,1.3a16.06,16.06,0,1,1-9-29.33,15.72,15.72,0,0,1,9,2.73C209.49,5.84,209.91,6.33,209.51,6.85Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.18,4.16a.91.91,0,0,1,.9-.92h6.24a1,1,0,0,1,1,.92V19.28h10.43V4.16a.91.91,0,0,1,.95-.92h6.15c.56,0,1,.27,1,.88V33.5a.88.88,0,0,1-1,.92h-6.21a.86.86,0,0,1-.95-.92V26.74H222.31V33.5c0,.58-.4.92-1.05.92h-6.18a.79.79,0,0,1-.9-.82Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.994af17dbbb619dc27b7090fe39f1e84.svg";
export { ForwardRef as ReactComponent };